import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import "./UserAdmin.scss";
import { emailRegex } from "@/configuration/formConfigurations";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { uploadFile } from "@/helpers/fileHelper";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
import base64url from "base64url";
import jwt from "jsonwebtoken";
import { debounce } from "lodash";
import XLSX from "xlsx";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = {
  id: "",
  active: true,
  web2print_url: "",
  typo3: [],
  avatar_uri: "",
  deleted: false,
  email: "",
  first_name: "",
  last_name: "",
  username: "",
  name: "",
  gender: "",
  groups: [],
  regions: [],
  isAdmin: false,
  phone: "",
  principal_id: "",
  scopes: [],
  newsletter: ["all"],
  email_notifications: ["extern_news_from_principal"]
};

export default {
  name: "UserAdmin",
  components: {
    AdminList
  },

  data: () => ({
    dragging: false,
    emailRegex,
    dialog: false,
    dialogDelete: false,
    isValid: false,
    visible: false,
    buttonText: "Neuer Benutzer",
    headers: [
      { text: "Name", value: "name" },
      { text: "Benutzername", value: "username" },
      { text: "Mandant", value: "principal.name" },
      { text: "Id", value: "id" },
      { text: "Aktionen", value: "actionChange", sortable: false }
    ],
    newsletter: [
      { name: "Alle", value: "all" },
      { name: "Datenpflege Erinnerung", value: "reminderDataCheck" },
      { name: "Marketing", value: "marketing" },
      { name: "Release-Updates", value: "releaseUpdates" }
    ],
    newsletterFilterOptions: [
      { name: "Alle", value: "all" },
      { name: "Datenpflege Erinnerung", value: "reminderDataCheck" },
      { name: "Marketing", value: "marketing" },
      { name: "Release-Updates", value: "releaseUpdates" }
    ],
    editedIndex: -1,
    editedUser: { ...defaultItem },
    addUsers: [
      {
        name: "",
        url: "",
        deleteTypo3: ""
      }
    ],
    genders: [
      { value: "none", title: "----" },
      { value: "female", title: "Frau" },
      { value: "male", title: "Herr" }
    ],
    regionPrincipalId: "00000000-0000-0000-0000-100000000000",
    regionUserFilterOptions: [
      { value: "regionUser", text: "Ist Regionsbenutzer" },
      { value: "noRegionUser", text: "Ist kein Regionsbenutzer" }
    ],
    regionUserFilter: "",
    selectedModule: "",
    searchValue: "",
    filteredUsers: null,
    principalFilter: "",
    newsletterFilter: "",
    regionFilter: "",
    activeFilter: "Alle",
    defaultFilter: { itemsPerPage: 25 },
    filter: {},
    loading: false
  }),

  methods: {
    editItem(item) {
      this.editedUser = item || { ...defaultItem };
      this.dialog = true;
      //dialog fenster öffnet sich → Datensatz kann bearbeitet werden
    },
    onNewsletterChange(value) {
      if (value <= 1) return;
      const lastItem = this.editedUser.newsletter.pop();
      if (lastItem === "all") {
        this.editedUser.newsletter = ["all"];
      } else {
        this.editedUser.newsletter = this.editedUser.newsletter.filter(
          n => n !== "all"
        );
        this.editedUser.newsletter.push(lastItem);
      }
    },
    addTypo3Access() {
      if (!Array.isArray(this.editedUser?.typo3)) this.editedUser.typo3 = [];

      this.editedUser?.typo3?.push({
        site: "",
        url: ""
      });
      this.editedUser = { ...this.editedUser };
    },
    async deleteTypo3Access(item) {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie diesen Zugang löschen möchten?",
        confirmWarningConfig
      );
      if (isConfirmed) this.editedUser?.typo3?.remove(item);
    },
    close() {
      this.editedUser = { ...defaultItem };
      this.dialog = false;
    },
    async save(closeDialog) {
      try {
        await this.uploadUserPicture();
        if (this.editedUser.regions?.length) {
          if (Array.isArray(this.editedUser.regions)) {
            this.editedUser.regions.remove(""); // Prevent saveing empty itemsr
          }

          if (!this.editedUser.groups?.length)
            this.editedUser.groups = ["628b5e36e06088f80f9dcd2b"];

          if (!this.editedUser.principal_id)
            this.editedUser.principal_id = this.REGION_PRINCIPAL;
        }
        const headers = getTokenHeader();
        if (this.editedUser.id) await this.updateUser(headers);
        else await this.createUser(headers);

        if (closeDialog) this.close();
      } catch (err) {
        if (err?.response?.data?.errors?.username?.unique)
          await this.$store.dispatch("createError", {
            ...err,
            text: "Dieser Benutzername ist bereits vergeben"
          });
        else await this.$store.dispatch("createError", err);
      }
    },
    getUserPicture() {
      return this.editedUser?.fileData ?? this.editedUser?.avatar_uri;
    },
    async setUserPicture(e) {
      const file = e?.dataTransfer?.files?.[0] ?? e;
      if (file) {
        this.editedUser.fileData = await this.readFileUrl(file);
        this.editedUser.avatar_uri = file;
      } else {
        this.clearImage();
      }
      this.dragging = false;
    },
    clearImage() {
      this.editedUser.avatar_uri = null;
      this.editedUser.fileData = null;
    },
    async uploadUserPicture() {
      if (
        this.editedUser.fileData &&
        typeof this.editedUser.avatar_uri !== "string"
      ) {
        const res = await uploadFile(
          this.editedUser.avatar_uri,
          this.editedUser.id,
          "users",
          this.editedUser.principal_id
        );
        delete this.editedUser.fileData;
        this.editedUser.avatar_uri = res.url;
      }
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async confirmRemoveAvatarImage() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Logo löschen möchten?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        await this.removeAvatarImage();
      }
    },
    async removeAvatarImage() {
      // TODO: Remove File from S3 / fix eo-file api
      this.clearImage();
    },
    async updateUser(headers) {
      const res = await axios.put(
        `${env.auth_api_client_url}users/update/`,
        this.editedUser,
        { headers }
      );
      if (res.status === 200) {
        await this.$store.dispatch("getAllUsers");
        await this.$store.dispatch(
          "createSuccess",
          "Benutzer wurde erfolgreich aktualisiert"
        );
      }
    },
    async createUser(headers) {
      const {
        status,
        data: { data }
      } = await axios.post(
        `${env.auth_api_client_url}users/add/`,
        this.editedUser,
        { headers }
      );
      if (status === 200 || status === 201) {
        this.editedUser = Array.isArray(data) ? data[0] : data;
        await this.$store.dispatch("getAllUsers");
        await this.$store.dispatch(
          "createSuccess",
          "Benutzer wurde erfolgreich angelegt"
        );
      }
    },
    async impersonate(user) {
      const login = await this.$confirm(
        `Als Benutzer "${user}" anmelden?`,
        confirmWarningConfig
      );
      if (login) {
        this.loginAs(user);
      }
    },

    loginAs: async function(username) {
      const sessionString = localStorage.getItem("session");
      const admin_token = JSON.parse(sessionString)?.token;

      const headers = {
        Authorization:
          "Basic " +
          base64url(env.auth_api_client_id + ":" + env.auth_api_client_secret)
      };
      let result;
      try {
        result = await axios.post(
          env.auth_api_client_url + "auth/",
          {
            grant_type: "impersonate",
            username,
            admin_token
          },
          {
            headers
          }
        );
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: `Einloggen als "${username}" fehlgeschlagen!`,
          ...error
        });
      }
      const token = result?.data?.access_token;
      if (token) {
        const decode = jwt.decode(token);
        localStorage.setItem(
          "session",
          JSON.stringify({
            token: token,
            user_id: decode.sub,
            scopes: decode.scope.split(" "),
            // PHPs Date Number hat 3 stellen weniger als die von JS.
            // Man landet immer in den 70ern wenn man die 3 stellen nicht anhängt
            expires: decode.exp * 1000
          })
        );
        localStorage.setItem("impersonatedBy", sessionString);

        localStorage.setItem("authRefreshToken", result?.data?.refresh_token);
        this.$store.state.session = {
          id: decode.sub,
          expires: decode.exp * 1000
        };
        window.location = "/";
      }
    },
    async applyFilter(filter) {
      if (filter?.limit) delete filter.limit;
      if (filter) await this.$store.dispatch("getAllUsers", filter);
      else {
        let usersToFilter = this.allUsers;

        if (this.principalFilter)
          usersToFilter = usersToFilter.filter(
            user => user.principal_id === this.principalFilter
          );

        if (this.regionUserFilter?.includes("regionUser")) {
          usersToFilter = usersToFilter.filter(user =>
            user.principal_id.includes(this.regionPrincipalId)
          );
        }

        if (this.regionUserFilter?.includes("noRegionUser")) {
          usersToFilter = usersToFilter.filter(
            user => !user.principal_id.includes(this.regionPrincipalId)
          );
        }

        if (this.selectedModule?.length) {
          usersToFilter = usersToFilter.filter(user => {
            return user.roles.some(role => {
              const module = this.modules.find(
                module => module._id === this.selectedModule
              );
              return module && module.roles.includes(role._id);
            });
          });
        }

        if (this.regionFilter)
          usersToFilter = usersToFilter.filter(user =>
            user.regions?.includes(this.regionFilter)
          );

        if (this.newsletterFilter) {
          usersToFilter = usersToFilter.filter(
            user =>
              user.newsletter?.includes(this.newsletterFilter) ||
              user.newsletter?.includes("all")
          );
        }

        switch (this.activeFilter) {
          case "Aktiv":
            usersToFilter = usersToFilter.filter(user => !!user.active);
            break;
          case "Inaktiv":
            usersToFilter = usersToFilter.filter(user => !user.active);
            break;
        }
        this.users = usersToFilter;
      }
    },
    exportXLSX() {
      const TABLE_TITLE_LINE = [
        "Anrede",
        "Vorname",
        "Nachname",
        "E-Mail",
        "Mandant",
        "Module",
        "Region"
      ];
      const table = [TABLE_TITLE_LINE];
      this.users.forEach(user => {
        table.push([
          this.mapGender(user.gender),
          user.first_name,
          user.last_name,
          user.email,
          this.getPrincipal(user.principal_id),
          this.getModuleInfO(user.roles),
          this.getUserRegion(user.regions)
        ]);
      });
      const ws = XLSX.utils.aoa_to_sheet(table);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Benutzer");
      XLSX.writeFile(workbook, `Benutzer.xlsx`);
    },
    getPrincipal(userPrincipal) {
      if (!userPrincipal) return "---";
      return this.principals.find(principal => principal._id === userPrincipal)
        ?.name;
    },
    getUserRegion(userRegions) {
      if (!userRegions?.length) return "---";
      const mappedRegions = userRegions.map(
        r => this.regions.find(region => region._id === r)?.title
      );
      return mappedRegions.join(", ");
    },
    mapGender(gender) {
      switch (gender) {
        case "none":
          return "---";
        case "male":
          return "Herr";
        case "female":
          return "Frau";
        default:
          return "---";
      }
    },
    getModuleInfO(userRoles) {
      if (!userRoles?.length) return "";
      const userModules = [];
      userRoles.forEach(role => {
        const foundModule = this.modules.find(m => m.roles.includes(role._id));
        if (foundModule?.name && !userModules.includes(foundModule?.name))
          userModules.push(foundModule.name);
      });
      return userModules.join(" - ");
    },
    resetFilter() {
      this.searchValue = "";
      this.principalFilter = "";
      this.regionFilter = "";
      this.activeFilter = "Alle";
      this.applyFilter();
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.applyFilter(this.filter);
    }, 500)
  },
  async mounted() {
    this.loading = true;
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    try {
      await this.$store.dispatch("getModules");
      await this.$store.dispatch("getAllUsers");
      await this.$store.dispatch("getGroups");
      await this.$store.dispatch("getRegions", {
        ignorePrincipalId: 1,
        listSearch: true
      });
    } catch (err) {
      await this.$store.dispatch("createError", err.message);
    }
    this.loading = false;
  },
  computed: {
    allUsers() {
      return this.$store.state.users;
    },
    modules() {
      return this.$store.state.allModules?.sort((firstItem, secondItem) =>
        firstItem.name.localeCompare(secondItem.name)
      );
    },
    users: {
      get() {
        return this.filteredUsers ?? this.allUsers;
      },
      set(value) {
        this.filteredUsers = value;
      }
    },
    principals() {
      return this.$store.state.principals;
    },
    groups() {
      return this.$store.state.groups;
    },
    regions() {
      return this.$store.state.regions;
    },
    userRegions: {
      get() {
        if (Array.isArray(this.editedUser?.regions))
          return this.editedUser?.regions;
        else if (typeof this.editedUser?.regions === "string")
          return this.editedUser.regions.split(", ");
        else return [];
      },
      set(value) {
        value.remove(""); // Prevent saving empty items
        this.editedUser.regions = value;
      }
    },
    isRegion: {
      get() {
        return this.editedUser?.principal_id === this.REGION_PRINCIPAL;
      },
      set(value) {
        if (this.editedUser)
          if (value) {
            this.editedUser.regions = "";
            this.editedUser.principal_id = this.REGION_PRINCIPAL;
          } else {
            this.editedUser.regions = null;
            this.editedUser.principal_id = "";
          }
      }
    },
    externNewsPrincipalNotification: {
      get() {
        const notifications = this.editedUser?.email_notifications || [];
        return notifications.includes("extern_news_from_principal");
      },
      set(value) {
        if (!value) {
          return;
        }

        if (!this.editedUser.email_notifications) {
          this.editedUser.email_notifications = [];
        }

        const index = this.editedUser.email_notifications.indexOf(
          "extern_news_from_principal"
        );
        if (index === -1) {
          this.editedUser.email_notifications.push(
            "extern_news_from_principal"
          );
        } else if (!value && index !== -1) {
          this.editedUser.email_notifications.splice(index, 1);
        }
      }
    }
  },
  watch: {
    searchValue() {
      this.applyFilter();
    },
    principalFilter() {
      this.applyFilter();
    },
    regionFilter() {
      this.applyFilter();
    },
    activeFilter() {
      this.applyFilter();
    }
  }
};
